/**
 * Prism OS — English translation.
 * Used for Meta App Review demo mode + screencast.
 */
import type { Dictionary } from "../types";

export const en: Dictionary = {
  common: {
    loading: "Loading...",
    error: "Something went wrong",
    retry: "Retry",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    confirm: "Confirm",
    search: "Search",
    filter: "Filter",
    export: "Export CSV",
    refresh: "Refresh",
    back: "Back",
    next: "Next",
    previous: "Previous",
    submit: "Submit",
    actions: "Actions",
    yes: "Yes",
    no: "No",
    empty: "No data",
    today: "Today",
    yesterday: "Yesterday",
    last7: "Last 7 days",
    last30: "Last 30 days",
    last90: "Last 90 days",
    settings: "Settings",
    logout: "Logout",
    language: "Language",
    languageUz: "Uzbek",
    languageEn: "English",
  },
  nav: {
    home: "Home",
    sales: "Sales",
    marketing: "Marketing",
    chatbot: "Chatbot",
    coach: "Coach",
    settings: "Settings",
  },
  chatbot: {
    nav: {
      dashboard: "Dashboard",
      inbox: "Inbox",
      analytics: "Analytics",
      leads: "Leads",
      knowledge: "Knowledge base",
      channels: "Channels",
      demo: "Demo mode",
    },
    dashboard: {
      title: "Chatbot dashboard",
      subtitle: "Real-time chatbot metrics and lead funnel",
      kpi: {
        activeConversations: "Active conversations",
        avgResponseTime: "Avg response time",
        conversionRate: "Conversion rate",
        totalLeads: "Total leads",
      },
      sections: {
        funnel: "Ads → Chat → Lead → Deal funnel",
        recentConversations: "Recent conversations",
        aiAcceptRate: "AI suggestion accept rate",
        channelBreakdown: "Per-channel performance",
      },
      empty: "No conversations yet",
    },
    analytics: {
      title: "Chatbot analytics",
      subtitle: "Deep insights and export",
      filters: {
        period: "Period",
        channel: "Channel",
        agent: "Agent",
      },
      charts: {
        dailyVolume: "Daily conversation volume",
        responseTime: "Response time histogram",
        intentBreakdown: "Intent breakdown",
        topFaq: "Top FAQ questions",
        aiHumanRatio: "AI vs human reply ratio",
        leadTimeline: "Lead conversion timeline",
      },
    },
    leads: {
      title: "Chatbot leads",
      subtitle: "All leads created via chatbot",
      columns: {
        contact: "Contact",
        intent: "Intent",
        channel: "Channel",
        amoStatus: "AmoCRM",
        createdAt: "Created",
        source: "Source",
      },
      amoStatus: {
        synced: "Synced",
        pending: "Pending",
        failed: "Failed",
        notSynced: "Not synced",
      },
    },
    funnel: {
      ad: "Ads",
      chat: "Chat",
      lead: "Lead",
      deal: "Deal",
    },
    intent: {
      FAQ: "FAQ",
      BUYER_INTENT: "Buyer intent",
      OBJECTION: "Objection",
      COMPLAINT: "Complaint",
      SMALL_TALK: "Small talk",
      OTHER: "Other",
    },
    demo: {
      title: "Meta App Review demo",
      banner: "Meta Reviewer Demo Mode — English UI",
      steps: {
        connect: "Connect Instagram",
        selectAccount: "Select Business account",
        inbox: "View Inbox (live messages)",
        reply: "Accept AI suggestion + Reply",
        verify: "Verify on Instagram app",
        comments: "Comment management",
      },
      next: "Next step",
      done: "Finish",
    },
  },
  legal: {
    privacy: {
      title: "Privacy Policy",
      lastUpdated: "Last updated: 2026-05-07",
    },
    terms: {
      title: "Terms of Service",
      lastUpdated: "Last updated: 2026-05-07",
    },
    deletion: {
      title: "Data deletion request",
      description:
        "Submit a request to delete data Prism OS has collected via Meta platform integrations.",
      submit: "Submit request",
      success: "Request received",
    },
  },
  errors: {
    generic: "Unexpected error",
    network: "Network error. Please try again",
    forbidden: "Access denied",
    notFound: "Not found",
    server: "Server error",
  },
};
